export const Realtime_Database_URL = 'https://yoga-club-nitk-website-default-rtdb.asia-southeast1.firebasedatabase.app/.json'

export const Storage_URL = 'https://firebasestorage.googleapis.com/v0/b/yoga-club-nitk-website.appspot.com/o/'
